<div class="modal-body modal-scss setOverflow">
  <div [formGroup]="form">
    <p-multiSelect
      [displaySelectedLabel]="true"
      selectedItemsLabel="{0} fichier(s) sélectionné(s)"
      [options]="mailFilesLV"
      [placeholder]="'pleaseSelectFiles' | translate"
      baseZIndex="1000"
      styleClass=""
      [filter]="true"
      optionLabel="label"
      styleClass="w-100"
      [emptyFilterMessage]="'noResultFound' | translate"
      formControlName="fileSelect"></p-multiSelect>
  </div>
  <div class="form-upload mt-4 mb-3 row">
    <div class="col-md-12">
      <p-fileUpload
        #pFileUpload
        name="myfileUpload[]"
        multiple="multiple"
        accept=".xls,.xlsx,.odt,.docx,.doc,.pptx,.ppt,.pdf,.rar,.zip,.json,.mp4,.msg,.rtf,.txt,.jpeg,.jpg,.png,.gif,.tiff,.eml"
        fileLimit="100"
        [showUploadButton]="false"
        [showCancelButton]="false"
        chooseLabel="Joindre des fichiers"
        styleClass="fileUploadCustom w-100"
        class="d-block w-100"
        [customUpload]="true"
        (onSelect)="onSelectFiles($event)"
        showChooseButton="false"
        showUploadButton="false"
        showCancelButton="false">
      </p-fileUpload>
    </div>
    <div class="col-md-12 d-flex justify-content-center align-items-center">
      <i-button [text]="'joinAFile' | translate" styleClass="green" (click)="onUploadClick()"></i-button>
    </div>
  </div>
  <i-button (click)="ref.close()" [text]="'close' | translate" styleClass="bottomButton red mb-3"> </i-button>
  <i-button (click)="submit()" [text]="'add' | translate" styleClass="bottomButton green"> </i-button>
</div>
